<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->



// FAQs
$('.faqsBox .faqsBoxTitle').click(function() {
  if ($(this).parent().hasClass("active")) {
    $(this).parent().removeClass("active").find(".faqsText").slideUp();
  } else {
    $(".faqsBox .faqsContent.active .faqsText").slideUp();
    $(".faqsBox .faqsContent.active").removeClass("active");
    $(this).parent().addClass("active").find(".faqsText").slideDown();
  }
  return false;
});


$('.menuSubItemCAN').click(function() {
  $(this).addClass('active');
  $('.menuSubItemUSA').removeClass('active');
  $('.storeListingCA').show();
  $('.storeListingUSA').hide();
  setTimeout(function () {
    if ($('.storeListingCA_click').hasClass("active")) {
      
    } else {
      $('.storeListingCA_click .storeListingHead h3').click();
    }
  }, 20);
});
$('.menuSubItemUSA').click(function() {
  $(this).addClass('active');
  $('.menuSubItemCAN').removeClass('active');
  $('.storeListingUSA').show();
  $('.storeListingCA').hide();
  setTimeout(function () {
    if ($('.storeListingUSA_click').hasClass("active")) {
      
    } else {
      $('.storeListingUSA_click .storeListingHead h3').click();
    }
  }, 20);
});

if (window.matchMedia("(max-width: 991px)").matches) {
  setTimeout(function () {
    $('.storeListingCA_click .storeListingHead h3').click();
  }, 20);
  $('.storeListingCA .storeListingHead h3').click(function() {
    if ($(this).parent().parent().parent().hasClass("active")) {
      $(this).parent().parent().parent().removeClass("active").find(".storeListing").slideUp();
    } else {
      $(".storeListingCA.active .storeListing").slideUp();
      $(".storeListingCA.active .storeListing").removeClass("active");
      $(this).parent().parent().parent().addClass("active").find(".storeListing").slideDown();
    }
    return false;
  });
  $('.storeListingUSA .storeListingHead h3').click(function() {
    if ($(this).parent().parent().parent().hasClass("active")) {
      $(this).parent().parent().parent().removeClass("active").find(".storeListing").slideUp();
    } else {
      $(".storeListingUSA.active .storeListing").slideUp();
      $(".storeListingUSA.active .storeListing").removeClass("active");
      $(this).parent().parent().parent().addClass("active").find(".storeListing").slideDown();
    }
    return false;
  });
}

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
